import { render, staticRenderFns } from "./SolicitudesReversion.vue?vue&type=template&id=62a75c43&scoped=true"
import script from "./SolicitudesReversion.vue?vue&type=script&lang=js"
export * from "./SolicitudesReversion.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesReversion.vue?vue&type=style&index=0&id=62a75c43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a75c43",
  null
  
)

export default component.exports